import { render, staticRenderFns } from "./SBSection.html?vue&type=template&id=48157a4e&scoped=true&"
import script from "./SBSection.ts?vue&type=script&lang=ts&"
export * from "./SBSection.ts?vue&type=script&lang=ts&"
import style0 from "./SBSection.css?vue&type=style&index=0&id=48157a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48157a4e",
  null
  
)

export default component.exports